import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

// 臥室測驗題庫（可彈性擴充）
const bedroomQuiz = [
  {
    title: "【你家的「臥室」，是黴菌偷偷潛伏的睡眠伴侶嗎？】",
    subtitle: "床架",
    image: process.env.PUBLIC_URL + "/img/bedroom-quiz1.webp",
    points: [
      { x: 65, y: 25, correct: false }, // 紅點
      { x: 40, y: 65, correct: true },  // 藍點（正確）
      { x: 60, y: 80, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🛏️床架不是免疫區！黴菌早就從床底慢慢爬上來啦～你是不是床架靠牆擺、底下堆雜物、幾乎從沒清過？👀長時間不通風、不清淨，再加上人體熱氣與濕氣，就讓床底變成黴菌溫床！",
        "常見黴菌有枝孢菌、黑麴黴、青黴菌，尤其是木質床架最容易吸濕發霉，表面可能長毛、變色、冒霉點。吸入孢子還可能導致過敏性鼻炎、氣喘惡化、皮膚搔癢，對過敏體質者特別不友善！",
        "✅床架防霉三招：",
        "1. 床架別靠牆貼太緊，底部要留空氣流通空間～🌬️",
        "2. 床底每月打掃一次，尤其角落灰塵別放過！🧹",
        "3. 潮濕季節可在床底放防霉產品～"
      ]
    }
  },
  {
    title: "【你家的「臥室」，是黴菌偷偷潛伏的睡眠伴侶嗎？】",
    subtitle: "棉被",
    image: process.env.PUBLIC_URL + "/img/bedroom-quiz2.webp",
    points: [
      { x: 35, y: 45, correct: true },  // 藍點（正確）
      { x: 68, y: 35, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "🛏️棉被不能蓋了就收！黴菌早就在被子裡躲起來啦～你是不是換季時直接把冬被塞進衣櫃？還有平常棉被很少曬、甚至濕濕的就收？👀皮屑、汗水、濕氣累積在被子裡，簡直是黴菌的夢幻樂園！",
        "最常見的有念珠菌、麴黴菌、枝孢菌，會讓棉被發霉、變味，嚴重甚至引發皮膚過敏、濕疹、呼吸道問題！",
        "✅棉被防霉三招：",
        "1. 被子至少每月曬一次，換季前徹底曬乾再收！☀️",
        "2. 起床不要馬上摺棉被，避免濕氣堆積💧",
        "3. 收納處保持乾燥，可搭配防霉產品或除濕機使用！"
      ]
    }
  },
  {
    title: "【你家的「臥室」，是黴菌偷偷潛伏的睡眠伴侶嗎？】",
    subtitle: "冷氣",
    image: process.env.PUBLIC_URL + "/img/bedroom-quiz3.webp",
    points: [
      { x: 35, y: 75, correct: false }, // 紅點
      { x: 35, y: 45, correct: true },  // 藍點（正確）
      { x: 60, y: 15, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "❄️冷氣的風安全嗎？黴菌早就在裡面開派對啦～你是不是一進夏天就猛開冷氣，但完全沒清潔濾網？👀濕氣+灰塵+冷凝水在機體內部累積，黴菌只要一週沒清就能開始滋長！",
        "最常見的黴菌有黑麴黴、煙麴黴、青黴菌，會附著在濾網、出風口、甚至冷排鰭片上。隨著冷氣運轉，黴菌孢子會被吹進空氣中，進入呼吸道，導致過敏、氣喘惡化、慢性鼻炎、甚至黴菌性肺炎（尤其免疫力低下者）！",
        "✅冷氣防霉三招：",
        "1. 冷氣濾網每2～4週拆下清洗，乾燥後再裝回！🍋",
        "2. 每半年請專業清潔冷氣內部（冷排、風扇）！💊",
        "3. 關閉冷氣前開啟送風功能，排出水氣～💧"
      ]
    }
  },
  {
    title: "【你家的「臥室」，是黴菌偷偷潛伏的睡眠伴侶嗎？】",
    subtitle: "衣櫃",
    image: process.env.PUBLIC_URL + "/img/bedroom-quiz4.webp",
    points: [
      { x: 40, y: 75, correct: true },  // 藍點（正確）
      { x: 65, y: 20, correct: false }, // 紅點
      { x: 65, y: 80, correct: false }, // 紅點
    ],
    info: {
      luluImg: process.env.PUBLIC_URL + "/img/20.webp",
      title: "Lulu防霉小教室",
      content: [
        "你是不是衣服塞滿、不常打開衣櫃，還在潮濕換季時收進沒全乾的衣服？👀小心，衣物+濕氣+密閉櫃子，黴菌根本在裡面開派對！",
        "最常在衣櫃發現的黴菌包括：麴菌、青黴菌、枝孢菌，這些黴菌特別愛棉質、毛料、皮革等天然材質。衣服發霉不只變黃變臭，孢子還會隨著穿著飄進鼻子、沾到皮膚，可能導致過敏、氣喘、皮膚癢、真菌感染！",
        "✅衣櫃防霉三招：",
        "1. 換季衣物務必完全曬乾再收！☀️",
        "2. 定期打開衣櫃通風、晾衣空間留點餘地！🌬️",
        "3. 衣櫃放防霉產品"
      ]
    }
  }
];

export default function Bedroom() {
  const [quizIdx, setQuizIdx] = useState(0);
  const [showInfo, setShowInfo] = useState(false);
  const [wrongClick, setWrongClick] = useState(false);
  const [done, setDone] = useState(false);
  const quiz = bedroomQuiz[quizIdx];
  const navigate = useNavigate();

  function handlePointClick(point) {
    if (point.correct) {
      setShowInfo(true);
    } else {
      setWrongClick(true);
      setTimeout(() => setWrongClick(false), 600);
    }
  }

  function handleNext() {
    if (quizIdx < bedroomQuiz.length - 1) {
      setQuizIdx(quizIdx + 1);
      setShowInfo(false);
      setWrongClick(false);
    } else {
      setDone(true);
    }
  }

  if (done) {
    return (
      <div className="bedroom-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: 0 }}>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16, paddingLeft: 20, paddingTop: 20 }}>
          <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
          <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
        </div>
        <div style={{ maxWidth: 900, margin: '0 auto', background: 'none', borderRadius: 12, padding: 0, textAlign: 'center', minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div style={{ fontSize: '3rem', fontWeight: 700, margin: '48px 0 0 0', letterSpacing: 2 }}>太棒了！臥室篇結束</div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
            <img src={process.env.PUBLIC_URL + '/img/finish.webp'} alt="Lulu thumbs up" style={{ width: 220, height: 220, objectFit: 'contain', background: '#444', borderRadius: '50%' }} />
          </div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 18px 0', letterSpacing: 1 }}>恭喜你找到臥室中黴菌喜歡生長的地方！</div>
          <div style={{ fontSize: '2.5rem', fontWeight: 500, margin: '0 0 36px 0', letterSpacing: 1 }}>快去檢查看看你的臥室中有沒有這些黴菌吧！</div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginBottom: 48 }}>
            <button
              className="main-btn"
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
              onClick={() => navigate('/diagnosis')}
            >
              去檢查
            </button>
            <button 
              onClick={() => navigate('/main')} 
              style={{ background: 'rgba(154, 71, 61, 0.97)', color: 'white', border: 'none', padding: '16px 32px', borderRadius: 8, fontSize: '1.5rem', fontWeight: 700, cursor: 'pointer' }}
            >
              回首頁
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bedroom-quiz-container" style={{ background: '#99C221', minHeight: '100vh', padding: '20px' }}>
      <div style={{ display: 'flex', gap: 24, alignItems: 'center', marginBottom: 16 }}>
        <Link to="/main" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 20, textDecoration: 'none' }}>無黴行動</Link>
        <Link to="/survey" style={{ color: '#2b9aff', fontWeight: 700, fontSize: 18, textDecoration: 'underline' }}>填寫問卷</Link>
      </div>
      <div style={{ maxWidth: 900, margin: '0 auto', background: 'white', borderRadius: 12, padding: 40, position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
            <div>
              <div style={{ fontSize: '2rem', fontWeight: 700, marginBottom: 8 }}>{quiz.title}</div>
              <div style={{ fontSize: '1.4rem', fontWeight: 500, marginBottom: 12 }}>{quiz.subtitle}</div>
              <div style={{ color: '#444', fontSize: '1rem', marginBottom: 8 }}>《點點看，黴菌在哪裡？》</div>
            </div>
            <img src={process.env.PUBLIC_URL + '/img/03.webp'} alt="Lulu" style={{ width: 120, height: 120, borderRadius: 14, background: '#eee' }} />
          </div>
        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
        <img
            src={quiz.image}
            alt="quiz"
            style={{ width: 340, height: 260, borderRadius: 10, objectFit: 'cover', border: '2px solid #bbb' }}
          />
          {quiz.points.map((p, idx) => (
            <div
              key={idx}
              onClick={() => handlePointClick(p)}
              style={{
                position: 'absolute',
                left: `calc(${p.x}% - 18px)`,
                top: `calc(${p.y}% - 18px)`,
                width: 36,
                height: 36,
                borderRadius: '50%',
                background: p.correct ? '#ff2e2e' : '#ff2e2e',
                border: '3px solid #fff',
                boxShadow: wrongClick && !p.correct ? '0 0 12px 4px #ff2e2e' : '0 2px 8px #0003',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                zIndex: 2,
                display: showInfo && !p.correct ? 'none' : 'block',
              }}
              title={p.correct ? '正確答案' : '不是這裡'}
            />
          ))}
        </div>

        {showInfo && (
          <>
            <div style={{ marginTop: 32, padding: 24, background: '#f8f8e8', borderRadius: 8, border: '2px solid #b0e0e6' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <img src={quiz.info.luluImg} alt="Lulu" style={{ width: 80, height: 80, marginRight: 24 }} />
                <h3 style={{ fontSize: '2rem', color: '#005f73', margin: 0 }}>{quiz.info.title}</h3>
              </div>
              {quiz.info.content.map((text, i) => <p key={i} style={{ fontSize: '1.2rem', color: '#333', lineHeight: 1.8, margin: '8px 0' }}>{text}</p>)}
            </div>
            <div style={{ textAlign: 'right', marginTop: 12 }}>
              <button onClick={handleNext} style={{
                background: '#4caf50',
                color: '#fff',
                fontSize: '1.1rem',
                fontWeight: 600,
                padding: '10px 32px',
                border: 'none',
                borderRadius: 8,
                boxShadow: '0 2px 8px #0001',
                cursor: 'pointer',
                marginRight: 8
              }}>
                {quizIdx < bedroomQuiz.length - 1 ? '下一題 →' : '完成'}
              </button>
            </div>
          </>
        )}
      </div>
  </div>);
}
